import {useEffect} from "react";
import {useJetSsoLinkStore} from "store/jet/jet-sso-link.store";
import {shallow} from "zustand/shallow";

type UseJetSsoLinkResult = [string | null, boolean];

/**
 * Returns the pair's JET magic link, or null when the integration is disabled
 * or the pair has not synced yet.
 */
const useJetSsoLink = (
  showId: string,
  exhibitorPairId?: string
): UseJetSsoLinkResult => {
  const {fetch, isLoading, link} = useJetSsoLinkStore(
    (state) => ({
      fetch: state.fetch,
      isLoading: state.isLoading,
      link: state.getByPairId(exhibitorPairId as string),
    }),
    shallow
  );

  useEffect(() => {
    if (showId && exhibitorPairId) {
      fetch(exhibitorPairId, showId);
    }
  }, [showId, exhibitorPairId]);

  return [link, isLoading];
};

export default useJetSsoLink;
